import { useQuery } from 'react-query';
import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';

export const useGetMonthlyDirectFormSubmissionHistogram = (
  identifier: string,
  from: Dayjs | null,
  to: Dayjs | null,
  customField: any,
  customFieldName: any,
) => {
  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));
  if (customField) {
    appendQueryParamIfNotEmpty(queryParams, 'customFieldId', customField);
  }
  if(customFieldName) {
    appendQueryParamIfNotEmpty(queryParams, 'customFieldName', customFieldName);
  }

  const queryKey = generateQueryKey(identifier, queryParams);

  return useQuery(
    [`reports_${queryKey}`],
    () => dataFetch.get(`${CORE_API_SUFFIX}form-submission/histogram/monthly/direct?${queryParams}`).then((res) => res.data),
  );
};
